/*
 * BuildDocs пользовательский интерфейс version 0.1.0
 *
 * Copyright © 2022 ООО АДАПТ info@acfs.spb.ru
 * You may use, distribute and modify this code under the
 * terms of the ООО АДАПТ license
 */

import { FunctionComponent } from 'react'

import { routes, useProjects, useRouter } from '@builddocs/data-management'
import {
  Box,
  CircularProgress,
  List,
  ListItem,
  ListItemText,
  ListItemButton,
  Stack,
  Typography,
} from '@mui/material'
import { Scrollbars } from 'react-custom-scrollbars'
import { NavLink, useMatch } from 'react-router-dom'

import { ContainerTree } from './ContainerTree'
import NavLinks from './NavLinks'
import { ProjectsSelector } from './ProjectsSelector'

const ProjectsNavWidget: FunctionComponent = () => {
  const { navigate } = useRouter()
  const matchProjectId = useMatch({ path: '/projects/:projectId/*', end: true })
  const match = useMatch({
    path: '/projects/:projectId/contracts/:contractId/*',
  })
  const currentProjectId =
    matchProjectId?.params.projectId ?? match?.params.projectId
  const currentContractId = match?.params.contractId

  const { projects, isLoading } = useProjects({
    pageNumber: 0,
    pageSize: 1000,
  })

  const selectedProject = currentProjectId
    ? projects?.find(p => p.projectId === currentProjectId)
    : projects[0]

  const changeProject = projectId => {
    navigate(routes.projects.project(projectId))
  }
  const tryToCreateContract = () => {
    const code = window.prompt('Введите код. Его можно запросить в поддержке.')

    if (code === '1313132018') {
      navigate(`/projects/${currentProjectId}/contracts/create`)
    }
  }

  return currentProjectId ? (
    <>
      <ProjectsSelector
        isLoading={isLoading}
        projects={projects}
        selectedProject={selectedProject}
        onChange={changeProject}
      />
      <NavLinks currentProjectId={currentProjectId} />
      <Box display="flex" justifyContent="space-between">
        <Typography color="text.secondary" ml={1.5} mt={1} variant="overline">
          Договоры
        </Typography>
        <Box
          sx={{ marginLeft: 1.5, marginTop: 1, cursor: 'pointer' }}
          onClick={() => tryToCreateContract()}
        >
          <Typography
            color="#0034AD"
            sx={{ textDecoration: 'none' }}
            variant="overline"
          >
            [ + ]
          </Typography>
        </Box>
      </Box>
      <Box
        component={Scrollbars}
        flexGrow={1}
        overflow="auto"
        sx={{ minHeight: 200 }}
      >
        <ContainerTree
          currentContractId={currentContractId}
          currentProjectId={currentProjectId}
        />
      </Box>
    </>
  ) : (
    <>
      <Typography color="text.secondary" ml={1.5} variant="overline">
        Проекты
      </Typography>
      <Box flexGrow={1} overflow="auto">
        <List dense disablePadding>
          {projects.length > 0 ? (
            projects.map(p => (
              <ListItem key={p.projectId} disablePadding>
                <ListItemButton onClick={() => changeProject(p.projectId)}>
                  <ListItemText
                    primary={
                      p.description ?? (
                        <Typography color="text.primary">Без имени</Typography>
                      )
                    }
                    secondary={
                      p.constructionAddress ?? (
                        <Typography color="text.secondary">
                          Без адреса
                        </Typography>
                      )
                    }
                  />
                </ListItemButton>
              </ListItem>
            ))
          ) : (
            <Stack alignItems="center" px={1.5}>
              {isLoading ? (
                <CircularProgress size={16} />
              ) : (
                <Typography sx={{ alignSelf: 'flex-start' }}>
                  Добавьте проект в{' '}
                  <NavLink to={routes.navigator.base()}>
                    панели управления
                  </NavLink>
                </Typography>
              )}
            </Stack>
          )}
        </List>
      </Box>
    </>
  )
}

export default ProjectsNavWidget
